import { cn, NoddiIcon } from 'noddi-ui-common';
import type { ReactNode } from 'react';

type Props = {
  isSelected: boolean;
  disabled?: boolean;
  onClick: () => void;
  children: ReactNode;
};

export const PickerRow = ({ isSelected, disabled, onClick, children }: Props) => (
  <button
    type='button'
    aria-pressed={isSelected}
    disabled={disabled}
    onClick={onClick}
    className={cn(
      // Borderless: a stack of outlined cards reads as heavier than the list it is.
      'flex w-full items-center gap-3 rounded-xl px-2 py-1.5 text-left transition-colors',
      isSelected ? 'bg-success/10 ring-1 ring-success/30 ring-inset' : 'hover:bg-accent',
      disabled && !isSelected && 'opacity-60'
    )}
  >
    <div className='min-w-0 flex-1'>{children}</div>
    {/* Always reserved, so the columns inside the rows line up whether or not a row is selected. */}
    <span className='flex w-4 shrink-0 justify-center'>
      {isSelected && <NoddiIcon name='CheckCircle' size='small' className='text-successDark' />}
    </span>
  </button>
);
